import { getBankList } from '@/apis/bank';
import { getFeatures } from '@/apis/features';
import { getNationalityList } from '@/apis/nationality';
import { getPaymentType } from '@/apis/payment';
import { HomeType } from '@/enums';

import { BankResponse } from '@/types/Bank';
import { FeatureConfig } from '@/types/Features';
import { NationalityResponse } from '@/types/Nationality';
import { PaymentType, PaymentTypeResponseWrapper } from '@/types/Payment';
import { CalculatorAmount, UiState } from '@/types/UiState';

import { PayloadAction, createSlice } from '@reduxjs/toolkit';

// initial state uses class instance
const initialState: UiState = {
  homeType: HomeType.Hohh,
  language: `en`,
  bankList: [],
  loading: false,
  error: false,
  payModes: {
    data: [],
    loading: false,
    errors: [],
    succeeded: false,
    message: ``,
  },
  nationalityList: [],
  showSummary: false,
  acknowledgeAffiliate: false,
};

export const uiStateSlice = createSlice({
  name: `uiState`,
  initialState,
  reducers: {
    resetUiState: () => {
      return initialState;
    },
    setHomeType: (state, action: PayloadAction<string>) => {
      state.homeType = action.payload;
    },
    setShowPriceSummary: (state, action: PayloadAction<boolean>) => {
      state.showSummary = action.payload;
    },
    updateContentCalculator: (
      state,
      action: PayloadAction<CalculatorAmount>,
    ) => {
      state.contentCalculator = action.payload;
    },
    setAcknowledgeAffiliate: (state, action: PayloadAction<boolean>) => {
      state.acknowledgeAffiliate = action.payload;
    },
    setIsLppsa: (state, action: PayloadAction<boolean>) => {
      state.isLppsa = action.payload;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(getBankList.pending, (state) => {
        state.loading = true;
        state.error = false;
      })
      .addCase(getBankList.fulfilled, (state, action) => {
        state.bankList = action.payload.data as BankResponse[];
        state.loading = false;
        state.error = false;
      })
      .addCase(getBankList.rejected, (state, action) => {
        state.loading = false;
        state.error = true;
      });

    builder
      .addCase(getNationalityList.pending, (state) => {
        state.loading = true;
        state.error = false;
      })
      .addCase(getNationalityList.fulfilled, (state, action) => {
        state.nationalityList = action.payload.data as NationalityResponse[];
        state.loading = false;
        state.error = false;
      })
      .addCase(getNationalityList.rejected, (state) => {
        state.loading = false;
        state.error = true;
      });

    builder
      .addCase(getPaymentType.pending, (state) => {
        state.payModes.loading = true;
      })
      .addCase(getPaymentType.fulfilled, (state, action) => {
        state.payModes = action.payload;
        state.payModes.loading = false;
      })
      .addCase(getPaymentType.rejected, (state, action) => {
        state.payModes = action.payload as PaymentTypeResponseWrapper<
          PaymentType[]
        >;
        state.payModes.loading = false;
      });

    builder
      .addCase(getFeatures.pending, (state) => {
        state.error = false;
      })
      .addCase(getFeatures.fulfilled, (state, action) => {
        state.features = action.payload as FeatureConfig;
        state.error = false;
      })
      .addCase(getFeatures.rejected, (state) => {
        state.error = true;
      });
  },
});

export const {
  resetUiState,
  setHomeType,
  setShowPriceSummary,
  updateContentCalculator,
  setAcknowledgeAffiliate,
  setIsLppsa,
} = uiStateSlice.actions;
export default uiStateSlice.reducer;
